import styled from 'styled-components';

export const UploadWrapper = styled.div``;
